import React from "react"

import { ContentTag, Obj, connect } from "scrivito"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantObj } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { ensureString } from "shared/lib/ensureString"
import { ImageOverlayView } from "shared/ui/image-overlay/ImageOverlayView"

export interface ProductImageOverlayPayload {
  obj: ProductObj | ProductBaseVariantObj
}

interface ProductImageOverlayComponentProps {
  payload: ProductImageOverlayPayload
}

function ProductImageOverlayComponent({
  payload
}: ProductImageOverlayComponentProps) {
  const { closeOverlay } = useCurrentOverlay()

  return (
    <ImageOverlayView
      onClose={closeOverlay}
      title={ensureString((payload.obj as Obj).get("title")) ?? undefined}
      content={
        <ContentTag
          content={payload.obj as Obj}
          attribute="imageWidgets"
          className="image-widget-list"
        />
      }
    />
  )
}

export const ProductImageOverlay = React.memo(
  connect(ProductImageOverlayComponent)
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PRODUCT_IMAGE_OVERLAY: ProductImageOverlayPayload
  }
}
